import { define, ui } from '@owenscorning/pcb.alpha';

export default define`Foamglas Blog Reusable`('0.0.1')({
  gutterless: true,
  view: () => <UI.Modules.Page.Reusable value={ {path: 'insulation', name: 'Foamglas Blog Reusable' } } />,
  edit: {}
});
